import SportsIcon from "@material-ui/icons/Sports";
import LabelIcon from "@material-ui/icons/Label";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { AppResource } from "../../../types/resource.types";
import AccountSettings from "../../AccountSettings";
import Chat from "../../Chat";
import { CoachReservationsList } from "../../Coaches/Reservations";
import CoachProfile from "../../Profiles/CoachProfile";
import CoachDashboard from "./Dashboard";
import { CoachesReviewsList } from "../../Coaches/Reviews";
import CoachAvailability from "../../Coaches/Availability";
import CoachSlotsCalendar from "../../Coaches/Calendar";
import CoachFullNotificationList from "../../Coaches/CoachesNotifications/CoachFullNotificationList";

export const coachAccount = {
  resources: [
    <Resource
      name={AppResource.coachReservations}
      list={CoachReservationsList}
      icon={LabelIcon}
      options={{
        label: "Reservations",
      }}
    />,
    <Resource
      name={AppResource.coachReviews}
      list={CoachesReviewsList}
      icon={SportsIcon}
      options={{
        label: "Reviews",
      }}
    />,
    <Resource name={AppResource.clients} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.coachAvailabilities}`} component={CoachAvailability} />,
    <Route exact path={`/${AppResource.coachSlotsCalendar}`} component={CoachSlotsCalendar} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.profile}`} component={CoachProfile} />,
    <Route exact path={`/${AppResource.notifications}`} component={CoachFullNotificationList} />,
  ],
  dashboard: CoachDashboard,
};
